'use client';

import React from "react";
import { LeaseProvider } from "@/components/context/LeaseContext";

const LeaseProviderWrapper = ({ children }: { children: React.ReactNode }) => {
    return (
        <LeaseProvider>
            {children}
        </LeaseProvider>
    );
};

export default LeaseProviderWrapper;
